import { VpTweenMethods, getVpConditionConf } from '@ps/bridge/qc/vp/config'
import store from '@ps/store'
import {
  astItemFactory,
  getActionEventConfig,
  getActionsFromNode,
  makeAction,
  makeCondition,
} from '@ps/store/workbench/visual-program/utils'
import qc from 'qc'
import _ from 'lodash'
import { cookActionForActionName } from '@ps/views/workbench/quick-tool-bar/event-action-manager/tools'
import { getDescendants } from '@ps/bridge/qc/node/utils'

export function getEventConfig(cmd: string) {
  const vpConditionConf = getVpConditionConf()
  let conf
  for (const i in vpConditionConf) {
    conf = vpConditionConf[i].find((_conf) => {
      return _conf.command === cmd
    })
    if (conf) {
      return conf
    }
  }
}

export function updateActionList(specifyActionList?: string[]) {
  const nodes = getDescendants(
    store.state.workspace.sceneManager.currentSceneNode,
  )
  let actionList = []
  nodes.forEach((node) => {
    actionList.push(getActionsFromNode(node))
  })
  actionList = actionList.flat()
  let actionList2 = []
  actionList.forEach((action) => {
    // 运算不加进动作列表
    if (action.category.indexOf('vp-param') > -1) {
      return
    }
    // 没有全局变量就不添加赋值运算
    if (
      action.method === 'vpCompute' &&
      store.state.workspace.globalVar.globalVar.length === 0
    ) {
      return
    }
    let exist = false
    for (const i in actionList2) {
      if (
        actionList2[i].script === action.script &&
        actionList2[i].method === action.method
      ) {
        exist = true
        break
      }
    }
    if (!exist) {
      actionList2.push(action)
    }
  })
  // 没有缓动动画时删掉分组动画系列的响应动作
  if (!actionList2.some((action) => action.script === 'qc.Tween')) {
    const groupTweenList = [
      VpTweenMethods.vpPlayTweenChildrenAll,
      VpTweenMethods.vpStopTweenChildrenAll,
      VpTweenMethods.vpPlayTweenChildrenAllGoOn,
    ]
    actionList2 = actionList2.filter(
      (action) => groupTweenList.indexOf(action.method) === -1,
    )
  }
  let ansActionList = {}
  actionList2.forEach((action) => {
    const category = action.category
    if (typeof ansActionList[category] === 'undefined') {
      ansActionList[category] = []
    }
    ansActionList[category].push(action)
  })
  if (specifyActionList) {
    const finalActionList = {}
    for (const i in ansActionList) {
      const action = ansActionList[i].filter(
        (item) => specifyActionList.indexOf(item.method) > -1,
      )
      if (action.length > 0) {
        finalActionList[i] = action
      }
    }
    ansActionList = finalActionList
  }
  store.commit('workspace/game/visualProgram/updateActionEventList', {
    actionEventList: ansActionList,
  })
}
// 不依赖UI直接添加一个事件块到vpAst
export function addEventItem({
  conditionNode,
  actionNode,
  handCmd,
  action,
  param,
  sceneNode,
}: {
  conditionNode: qc.Node
  actionNode: qc.Node
  handCmd: string
  action: string
  param?: any
  sceneNode?: qc.Node
}) {
  const conf = getEventConfig(handCmd)
  const condition = makeCondition({
    uuid: conditionNode.uuid,
    conf,
  })
  const astItem = astItemFactory(condition)
  updateActionList()
  const actionEventList =
    store.state.workspace.game.visualProgram.actionEventList
  const taction = _.flattenDeep(Object.values(actionEventList)).find((item) => {
    return item.method === action
  })
  const actionEvent = cookActionForActionName(_.cloneDeep(taction), true)
  const actionEventConfig = getActionEventConfig(actionEvent, actionEventList)
  const ansAction = makeAction({
    selectTarget: actionNode,
    actionEvent: actionEvent,
    actionParams: param,
    actionEventConfig,
  })
  astItem.action.push(ansAction)
  const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
  let node
  if (sceneNode) {
    node = sceneNode
  } else {
    node = currentSceneNode
  }
  let vpAst = node.getScript('playsmart.editor.data').vpAst
  vpAst = [...Object.values(vpAst)]
  vpAst.push(astItem)
  store.dispatch('workspace/game/visualProgram/saveAST', {
    sceneNode: node,
    ast: vpAst,
    noAstUpdate: node.uuid !== currentSceneNode.uuid,
  })
  updateActionList(['vpInstall', 'vpSendAction', 'vpResumeVideo'])
}
// 根据节点的uuid获取其事件手势
export function getEventHandByNodeUuid(
  sceneNode: qc.Node,
  uuid: string,
): string {
  const vpAst = sceneNode.getScript('playsmart.editor.data').vpAst
  for (const i in vpAst) {
    if (vpAst[i].condition.length > 0) {
      const condition = vpAst[i].condition.find((item) => item.node === uuid)
      if (condition) {
        return condition.content
      }
    }
  }
  return 'DOWN'
}
